import { render, staticRenderFns } from "./FormAsterisk.vue?vue&type=template&id=e2c63eb4"
import script from "./FormAsterisk.vue?vue&type=script&lang=js"
export * from "./FormAsterisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c63eb4')) {
      api.createRecord('e2c63eb4', component.options)
    } else {
      api.reload('e2c63eb4', component.options)
    }
    module.hot.accept("./FormAsterisk.vue?vue&type=template&id=e2c63eb4", function () {
      api.rerender('e2c63eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormAsterisk.vue"
export default component.exports